import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './Header.css';
import { getAboutSettings, getContactSettings } from '../firebase/dataService';

function Header({ profile = { name: 'سلمان بن عبدالله الحران' } }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [aboutVisible, setAboutVisible] = useState(true);
  const [contactVisible, setContactVisible] = useState(true);
  const [headerSearch, setHeaderSearch] = useState('');

  const getHijriDate = () => {
    const now = new Date();
    const dayName = now.toLocaleDateString('ar-SA-u-ca-islamic', { weekday: 'long' });
    const day = now.toLocaleDateString('ar-SA-u-ca-islamic', { day: 'numeric' });
    const month = now.toLocaleDateString('ar-SA-u-ca-islamic', { month: 'long' });
    const year = now.toLocaleDateString('ar-SA-u-ca-islamic', { year: 'numeric' });
    return `${dayName} ${day} ${month} ${year}`;
  };

  const handleHeaderSearch = (e) => {
    e.preventDefault();
    if (headerSearch.trim()) {
      navigate('/', { state: { headerSearchTerm: headerSearch.trim() } });
      setHeaderSearch('');
    }
  };

  useEffect(() => {
    loadPagesVisibility();
  }, []);

  const loadPagesVisibility = async () => {
    try {
      const aboutSettings = await getAboutSettings();
      setAboutVisible(aboutSettings?.visible !== false);
      
      const contactSettings = await getContactSettings();
      setContactVisible(contactSettings?.visible !== false);
    } catch (error) {
      console.error('Error loading pages visibility:', error);
      setAboutVisible(true);
      setContactVisible(true);
    }
  };

  return (
    <>
    <header className="header">
      <span className="hijri-date-corner">{getHijriDate()}</span>
      <div className="header-content">
        <div className="profile-section">
          <div className="profile-info">
            <p className="profile-subtitle">موقع الفقير إلى الله :</p>
            <img
              src="/name-logo.png"
              alt="سلمان بن عبدالله الحران"
              className="profile-name-image"
            />
            <p className="profile-bio">نشر العلم عبادة وقربة لله ﷻ.<br />قال سفيان الثوري: " لا أعلم من العبادة شيئاً أفضل من أن تُعلِّم الناس العلم "</p>
          </div>
        </div>
<div className="search-social-row">
        <form className="header-search-bar" onSubmit={handleHeaderSearch}>
          <button type="submit" className="header-search-icon-btn" aria-label="بحث">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" width="18" height="18">
              <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
            </svg>
          </button>
          <input
            type="text"
            className="header-search-input"
            placeholder="كلمة البحث..."
            value={headerSearch}
            onChange={(e) => setHeaderSearch(e.target.value)}
          />
          <button type="submit" className="header-search-submit">
            بحث
          </button>
        </form>
        <div className="header-social-links">
          <div className="header-social-icons-row">
          <a href="https://x.com/salman_alKhatep" target="_blank" rel="noopener noreferrer" className="header-social-btn" title="تويتر"
            onClick={(e) => { if (/Android|iPhone|iPad|iPod/i.test(navigator.userAgent)) { e.preventDefault(); window.location.href = 'twitter://user?screen_name=salman_alKhatep'; setTimeout(() => window.open('https://x.com/salman_alKhatep', '_blank'), 1500); } }}>
            <svg viewBox="0 0 24 24" fill="currentColor" className="social-icon"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
          </a>
          <a href="https://youtube.com/channel/UCJCc6TojI38et5ckeUikRWg?si=SV2ju6GjGLgrKHTB" target="_blank" rel="noopener noreferrer" className="header-social-btn" title="يوتيوب"
            onClick={(e) => { if (/Android|iPhone|iPad|iPod/i.test(navigator.userAgent)) { e.preventDefault(); window.location.href = 'vnd.youtube://channel/UCJCc6TojI38et5ckeUikRWg'; setTimeout(() => window.open('https://youtube.com/channel/UCJCc6TojI38et5ckeUikRWg?si=SV2ju6GjGLgrKHTB', '_blank'), 1500); } }}>
            <svg viewBox="0 0 24 24" fill="currentColor" className="social-icon"><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>
          </a>
          <a href="https://t.me/salman_alkhatep" target="_blank" rel="noopener noreferrer" className="header-social-btn" title="تلجرام"
            onClick={(e) => { if (/Android|iPhone|iPad|iPod/i.test(navigator.userAgent)) { e.preventDefault(); window.location.href = 'tg://resolve?domain=salman_alkhatep'; setTimeout(() => window.open('https://t.me/salman_alkhatep', '_blank'), 1500); } }}>
            <svg viewBox="0 0 24 24" fill="currentColor" className="social-icon"><path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/></svg>
          </a>
          </div>
        </div>
        </div>

        <div className="header-decoration">
          <div className="circle circle-1"></div>
          <div className="circle circle-2"></div>
          <div className="circle circle-3"></div>
        </div>
      </div>
    </header>
    <nav className="header-nav">

      <Link to="/" className={`nav-link ${location.pathname === '/' ? 'active' : ''}`}>
        <span className="nav-icon">
          <svg viewBox="0 0 24 24" fill="currentColor"><path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/></svg>
        </span>
        <span className="nav-label">الرئيسية</span>
      </Link>
      <Link to="/scholars" className={`nav-link ${location.pathname === '/scholars' ? 'active' : ''}`}>
        <span className="nav-icon">
          <svg viewBox="0 0 24 24" fill="currentColor"><path d="M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 4h2v5l-1-.75L9 9V4zm9 16H6V4h1v9l3-2.25L13 13V4h5v16z"/></svg>
        </span>
        <span className="nav-label">من درر السلف</span>
      </Link>
      <Link to="/categories" className={`nav-link ${location.pathname === '/categories' ? 'active' : ''}`}>
        <span className="nav-icon">
          <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l-5.5 9h11zm0 3.84L14.6 9.5h-5.2zM17.5 13c-2.49 0-4.5 2.01-4.5 4.5S15.01 22 17.5 22s4.5-2.01 4.5-4.5S19.99 13 17.5 13zm0 7c-1.38 0-2.5-1.12-2.5-2.5S16.12 15 17.5 15s2.5 1.12 2.5 2.5S18.88 20 17.5 20zM3 21.5h8v-8H3v8zm2-6h4v4H5v-4z"/></svg>
        </span>
        <span className="nav-label">التصنيفات</span>
      </Link>
      {contactVisible && (
      <Link to="/contact" className={`nav-link ${location.pathname === '/contact' ? 'active' : ''}`}>
        <span className="nav-icon">
          <svg viewBox="0 0 24 24" fill="currentColor"><path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/></svg>
        </span>
        <span className="nav-label">تواصل معنا</span>
      </Link>
      )}
    </nav>
    </>
  );
}

export default Header;
